import { trackFeatureUsage } from '@animoto/utils/analytics';
import splunk from '@animoto/utils/splunk';

const DEFAULT_SCOPE = 'visitor-play-page';

function trackPlayerEvent(scope, event) {
  trackFeatureUsage({
    scope,
    feature : 'player',
    action  : `${event}:final-player`
  });
}

export default function setupTracking(videoPlayer, { scope = DEFAULT_SCOPE } = {}) {
  trackFeatureUsage({
    scope,
    feature : 'player',
    action  : 'view:final-player'
  });

  videoPlayer.on('error', (event) => {
    splunk({
      kind  : 'player_error',
      error : `${scope}: ${event.message}`
    });
  });

  videoPlayer.once('ready', () => {
    trackPlayerEvent(scope, 'initialized');
  });

  videoPlayer.once('play', () => {
    trackPlayerEvent(scope, 'started');
  });

  videoPlayer.once('ended', () => {
    trackPlayerEvent(scope, 'ended');
  });
}
